/*
    Методы нормализации ГДИ данных для отрисовки в:
    - список (отвечает за видимость исследований)
    - шапку в виде небольших колонок-исследований
*/
export const normalize = {
    toList(data) {
        if (!data) return [];

        return data.map(dataItem => {
            const { wellId, date, descr, data } = dataItem;

            return {
                wellId,
                date,
                description: descr,
                stratumTitles: [...new Set(data.map(item => item.stratumTitle))].join(','),
                hasData: data.length > 0,
            };
        });
    },
    toHead(data) {
        return data.map(dataItem => (dataItem.data.length > 0 ? dataItem.date : ''));
    },
};

export const gdiResearchesToHeader = data => {
    return data.reduce((acc, dataItem, i) => {
        if (dataItem.data.length > 0) {
            acc.push({ date: dataItem.date, index: i + 1, originalIndex: i });
        }
        return acc;
    }, []);
};

export const prepareResearchDates = data => {
    /*
        Исследования, у которых пустое поле data,
        не должны участвовать в отображении (как и в логике переключения отображения)
    */
    return data.reduce((acc, research, index) => {
		const compositeKey = `${research.date}_${index}`;
		acc[compositeKey] = research.data.length > 0;
		return acc;
	}, {});
};
